(function(){
  'use strict';
  var $=function(s,c){return (c||document).querySelector(s)};
  var $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var money=function(c){var f=(window.BOPPR&&BOPPR.moneyFormat)||'$'+'{{amount}}';var v=(c/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/,v)};

  /* header scroll state */
  var header=$('.site-header');
  var onScroll=function(){if(header)header.classList.toggle('is-scrolled',window.scrollY>30)};
  window.addEventListener('scroll',onScroll,{passive:true});onScroll();

  /* drawers */
  function openDrawer(id){var d=document.getElementById(id);if(!d)return;d.classList.add('is-open');document.body.style.overflow='hidden'}
  function closeDrawers(){$$('.drawer.is-open').forEach(function(d){d.classList.remove('is-open')});document.body.style.overflow=''}
  document.addEventListener('click',function(e){
    var o=e.target.closest('[data-open]');if(o){e.preventDefault();if(o.dataset.open==='cart-drawer')refreshCart();openDrawer(o.dataset.open);return}
    if(e.target.closest('[data-close]')){e.preventDefault();closeDrawers()}
    var t=e.target.closest('.mnav .toggle');if(t){e.preventDefault();t.closest('li').classList.toggle('open')}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeDrawers()});

  /* toast */
  function toast(msg){var t=$('.toast');if(!t){t=document.createElement('div');t.className='toast';document.body.appendChild(t)}t.textContent=msg;t.classList.add('is-show');clearTimeout(t._t);t._t=setTimeout(function(){t.classList.remove('is-show')},2600)}

  /* cart */
  function renderCart(cart){
    $$('[data-cart-count]').forEach(function(el){el.textContent=cart.item_count});
    var box=$('[data-cart-items]');if(!box)return;
    var thr=parseInt((window.BOPPR&&BOPPR.freeShip)||0,10)*100;
    var fs=$('[data-free-ship]');
    if(fs){if(thr>0&&cart.item_count){var left=thr-cart.total_price;fs.hidden=false;fs.querySelector('p').textContent=left>0?('You are '+money(left)+' away from FREE shipping'):'You unlocked FREE shipping!';fs.querySelector('span').style.width=Math.min(100,cart.total_price/thr*100)+'%'}else fs.hidden=true}
    if(!cart.item_count){box.innerHTML='<div class="cart-empty"><p>Your cart is currently empty.</p><a class="btn btn--primary" href="'+root+'collections/all">Return to shop</a></div>';$('[data-cart-foot]').hidden=true;return}
    $('[data-cart-foot]').hidden=false;
    $('[data-cart-total]').textContent=money(cart.total_price);
    box.innerHTML=cart.items.map(function(it,i){
      var img=it.image?it.image.replace(/(\.[a-z]+)(\?|$)/i,'$1$2')+(it.image.indexOf('?')>-1?'&':'?')+'width=160':'';
      var v=(it.variant_title&&it.variant_title!=='Default Title')?'<span class="cd-item__variant">'+it.variant_title+'</span>':'';
      return '<div class="cd-item"><img src="'+img+'" alt="" loading="lazy"><div><a class="cd-item__title" href="'+it.url+'">'+it.product_title+'</a>'+v+
      '<div class="qty"><button type="button" data-line-qty="'+(i+1)+'" data-q="'+(it.quantity-1)+'">&minus;</button><input type="number" value="'+it.quantity+'" readonly><button type="button" data-line-qty="'+(i+1)+'" data-q="'+(it.quantity+1)+'">+</button></div></div>'+
      '<div style="text-align:right"><div class="cd-item__price">'+(it.original_line_price>it.final_line_price?'<s style="color:#999;font-weight:400;margin-right:6px">'+money(it.original_line_price)+'</s>':'')+money(it.final_line_price)+'</div><button class="cd-item__remove" aria-label="Remove" data-line-qty="'+(i+1)+'" data-q="0">&times;</button></div></div>';
    }).join('');
  }
  function refreshCart(){return fetch(root+'cart.js',{credentials:'same-origin'}).then(function(r){return r.json()}).then(function(c){renderCart(c);return c})}
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-line-qty]');if(!b)return;e.preventDefault();
    fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:+b.dataset.lineQty,quantity:+b.dataset.q})}).then(function(r){return r.json()}).then(renderCart);
  });
  function addToCart(items,btn){
    if(btn){btn.disabled=true;btn._t=btn.innerHTML;btn.innerHTML='Adding...'}
    return fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})
      .then(function(){return refreshCart()}).then(function(){openDrawer('cart-drawer')})
      .catch(function(err){toast((err&&(err.description||err.message))||'Could not add to cart')})
      .finally(function(){if(btn){btn.disabled=false;btn.innerHTML=btn._t}});
  }
  document.addEventListener('click',function(e){
    var q=e.target.closest('[data-quick-add]');if(!q)return;e.preventDefault();
    addToCart([{id:+q.dataset.quickAdd,quantity:1}],q);
  });
  document.addEventListener('submit',function(e){
    var f=e.target.closest('form[data-product-form]');if(!f)return;e.preventDefault();
    var id=f.querySelector('[name=id]').value,qty=+(f.querySelector('[name=quantity]')||{value:1}).value||1;
    addToCart([{id:+id,quantity:qty}],f.querySelector('[type=submit]'));
  });
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-qty-step]');if(!b)return;e.preventDefault();
    var inp=b.parentNode.querySelector('input');inp.value=Math.max(1,(+inp.value||1)+(+b.dataset.qtyStep));
  });

  /* product page */
  $$('[data-product]').forEach(function(wrap){
    var data=JSON.parse($('[data-product-json]',wrap).textContent);
    var form=$('form[data-product-form]',wrap),idInput=$('[name=id]',form),btn=$('[type=submit]',form);
    var priceEl=$('[data-price]',wrap);
    function currentOptions(){
      return $$('[data-option-index]',wrap).reduce(function(acc,el){
        var i=+el.dataset.optionIndex;
        if(el.tagName==='SELECT')acc[i]=el.value;
        else{var c=$('input:checked',el);if(c)acc[i]=c.value}
        return acc},[]);
    }
    function update(variant){
      if(!variant){btn.disabled=true;btn.textContent='Unavailable';return}
      idInput.value=variant.id;
      btn.disabled=!variant.available;btn.textContent=variant.available?(btn.dataset.label||'Add to cart'):'Sold out';
      var html='';
      if(variant.compare_at_price>variant.price){html='<s>'+money(variant.compare_at_price)+'</s>'+money(variant.price)+'<span class="pdp__save">SAVE '+Math.round((1-variant.price/variant.compare_at_price)*100)+'%</span>'}
      else html=money(variant.price);
      priceEl.innerHTML=html;
      if(variant.featured_media){showMedia(variant.featured_media.id)}
      var url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState(null,'',url);
      $$('.vcard',wrap).forEach(function(c){c.classList.toggle('is-checked',$('input',c).checked)});
    }
    wrap.addEventListener('change',function(e){
      if(!e.target.closest('[data-option-index]'))return;
      var opts=currentOptions();
      var v=data.variants.find(function(v){return v.options.every(function(o,i){return o===opts[i]})});
      update(v);
    });
    function showMedia(id){
      var t=$('[data-thumb="'+id+'"]',wrap);if(t)t.click();
    }
    var main=$('[data-main-img]',wrap);
    wrap.addEventListener('click',function(e){
      var t=e.target.closest('[data-thumb]');if(!t)return;
      $$('[data-thumb]',wrap).forEach(function(x){x.classList.toggle('is-active',x===t)});
      main.style.opacity=0;setTimeout(function(){main.src=t.dataset.src;main.srcset='';main.style.opacity=1},150);
    });
    $$('.vcard',wrap).forEach(function(c){c.classList.toggle('is-checked',$('input',c).checked)});
  });

  /* essentials image rotators */
  $$('[data-rotate]').forEach(function(m,k){
    var imgs=$$('img',m);if(imgs.length<2)return;var i=0;
    setInterval(function(){imgs[i].classList.remove('is-active');i=(i+1)%imgs.length;imgs[i].classList.add('is-active')},2600+k*180);
  });

  /* tabs */
  $$('[data-tabs]').forEach(function(t){
    t.addEventListener('click',function(e){
      var b=e.target.closest('[data-tab]');if(!b)return;
      $$('[data-tab]',t).forEach(function(x){x.classList.toggle('is-active',x===b)});
      $$('.tab-panel',t).forEach(function(p){p.classList.toggle('is-active',p.id===b.dataset.tab)});
    });
  });

  /* reveal on view */
  var pending=$$('.reveal,[data-inview],.burst');
  function showEl(el){el.classList.add('is-inview','is-on')}
  var io=('IntersectionObserver' in window)?new IntersectionObserver(function(ents){ents.forEach(function(en){if(en.isIntersecting){showEl(en.target);io.unobserve(en.target)}})},{threshold:.2}):null;
  pending.forEach(function(el){io?io.observe(el):showEl(el)});
  var sweepT=null;
  function sweep(){sweepT=null;var vh=window.innerHeight;pending=pending.filter(function(el){if(el.classList.contains('is-inview'))return false;var r=el.getBoundingClientRect();if(r.top<vh*0.9){showEl(el);if(io)io.unobserve(el);return false}return true})}
  window.addEventListener('scroll',function(){if(!sweepT)sweepT=setTimeout(sweep,120)},{passive:true});
  window.addEventListener('load',sweep);setTimeout(sweep,300);

  /* scroll driven */
  var scrubs=$$('[data-scrub]');
  var orbits=$$('[data-orbit]');
  function progress(el){var r=el.getBoundingClientRect(),vh=window.innerHeight;return Math.min(1,Math.max(0,(vh-r.top)/(vh+r.height)))}
  var ticking=false;
  function frame(){
    ticking=false;
    scrubs.forEach(function(s){
      var p=progress(s.closest('section')||s);
      var local=Math.min(1,Math.max(0,(p-.15)/.55));
      var tag=$('.sphone__tag',s),frames=$$('.sphone__frames img',s);
      if(tag){tag.style.setProperty('--ty',(-60+local*95)+'px');tag.style.setProperty('--rot',(-25+local*25)+'deg')}
      s.classList.toggle('is-bopped',local>.55&&local<1);
      if(frames.length){var idx=Math.min(frames.length-1,Math.floor(local*frames.length*0.999));frames.forEach(function(f,i){f.classList.toggle('is-active',i===idx)})}
    });
    orbits.forEach(function(o){
      var p=progress(o);
      var inner=$('.orbit__inner',o),outer=$('.orbit__outer',o);
      if(inner)inner.style.setProperty('--spin',(p*220)+'deg');
      if(outer)outer.style.setProperty('--spin',(-p*160)+'deg');
    });
  }
  function req(){if(!ticking){ticking=true;requestAnimationFrame(frame)}}
  if(scrubs.length||orbits.length){window.addEventListener('scroll',req,{passive:true});window.addEventListener('resize',req);frame()}

  /* burst icon positions */
  $$('.burst').forEach(function(b){
    var icons=$$('.burst__icon',b),n=icons.length,w=b.clientWidth;
    icons.forEach(function(ic,i){
      var a=(i/n)*Math.PI*2,rx=Math.min(w*.46,420),ry=190*(w<640?.8:1);
      ic.style.setProperty('--x',(Math.cos(a)*rx*(0.8+((i*37)%20)/100))+'px');
      ic.style.setProperty('--y',(Math.sin(a)*ry*(0.8+((i*53)%20)/100))+'px');
      ic.style.setProperty('--r',(((i*29)%40)-20)+'deg');
      ic.style.transitionDelay=(i*0.04)+'s';
    });
  });

  /* hero scroll */
  $$('[data-scroll-next]').forEach(function(b){b.addEventListener('click',function(){var s=b.closest('section');var n=s&&s.parentElement.nextElementSibling;window.scrollTo({top:(s.getBoundingClientRect().bottom+scrollY-70),behavior:'smooth'})})});

  /* sort */
  $$('[data-sort]').forEach(function(s){s.addEventListener('change',function(){var u=new URL(location.href);u.searchParams.set('sort_by',s.value);location.href=u})});

  window.BopprCart={refresh:refreshCart,add:addToCart};
})();
